<ng-container *ngIf="groupLabel || isDivider; else optionItemTemplate">
  <div
    *ngIf="showDivider"
    class="phx-divider-wrap"
    [ngStyle]="groupDividerHeight !== null || isDivider ? { height: groupDividerHeight + 'px' } : {}"
  >
    <phx-divider></phx-divider>
  </div>
  <div *ngIf="groupLabel" class="phx-select-group-label-content" [ngClass]="{'custom-scroll-group-label': isCustomScrollEnabled }">
    {{ groupLabel }}
  </div>
</ng-container>

<ng-template #optionItemTemplate>
  <ng-container *ngIf="!isTreeView; else treeViewTemplate">
    <ng-container *ngIf="!optionTemplate; else customOptionTemplate">
      <ng-container *ngTemplateOutlet="tooltipWrapper; context: {
        content: standardOptionContent,
        className: 'phx-select-option-content' + (((multiple || showRadio) && !isLink) || prefixIcon ? ' phx-select-option-content-with-prefix' : '')
      }"></ng-container>
      <ng-container *ngIf="children?.length && !searched" [ngTemplateOutlet]="nestedMenuNavigator"></ng-container>
    </ng-container>

    <ng-template #customOptionTemplate>
      <ng-container *ngTemplateOutlet="tooltipWrapper; context: {
        content: customOptionContent,
        className: 'phx-select-option-content'
      }"></ng-container>
    </ng-template>
  </ng-container>

  <ng-template #treeViewTemplate>
    <ng-container *ngTemplateOutlet="tooltipWrapper; context: {
      content: treeViewContent,
      className: 'phx-select-option-content phx-select-option-tree'
    }"></ng-container>
  </ng-template>
</ng-template>

<!-- Tooltip wrapper template - handles user provided tooltip vs auto-truncation tooltip -->
<ng-template #tooltipWrapper let-content="content" let-className="className">
  <!-- User-provided tooltip: always show on hover (on the whole option) when feature flag is enabled -->
  <div
    *ngIf="tooltip && isCustomTooltipEnabled; else tooltipOnTruncate"
    [class]="className"
    phx-tooltip
    [phxContent]="tooltip"
  >
    <ng-container [ngTemplateOutlet]="content"></ng-container>
  </div>

  <!-- No user tooltip: individual elements (label, subtext) will have their own truncation tooltips -->
  <ng-template #tooltipOnTruncate>
    <div [class]="className">
      <ng-container [ngTemplateOutlet]="content"></ng-container>
    </div>
  </ng-template>
</ng-template>

<!-- Content templates for each option type -->
<ng-template #standardOptionContent>
  <ng-container [ngTemplateOutlet]="optionItemMainContent"></ng-container>
</ng-template>

<ng-template #customOptionContent>
  <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: templateContext }"></ng-container>
</ng-template>

<ng-template #treeViewContent>
  <ng-container *ngIf="!searched" [ngTemplateOutlet]="treeExpandCollapseHandle"></ng-container>
  <ng-container [ngTemplateOutlet]="optionItemMainContent"></ng-container>
</ng-template>

<ng-template #optionItemMainContent>
  <phx-checkbox
    *ngIf="multiple && !prefixIcon && !isLink"
    [phxChecked]="selected"
    [disabled]="disabled"
    [phxIndeterminate]="isIndeterminate"
    (phxCheckedChange)="changeSelection()"
    [tabIndex]="-1"
  ></phx-checkbox>
  <i *ngIf="prefixIcon" class="phx-select-option-prefix-icon" phx-icon [phxIcon]="prefixIcon" color="currentColor"></i>
  <label *ngIf="showRadio && !multiple && !isLink" phx-radio [ngModel]="selected" [phxDisabled]="disabled" (mouseup)="changeSelection()"></label>

  <div
    class="phx-select-option-label"
    phx-tooltip
    phx-tooltip-on-truncate
    [phxContent]="!(tooltip && isCustomTooltipEnabled) && isTooltipOnTruncateEnabled ? labelTooltipContent : null"
  >
    <ng-container *ngIf="searched && isNestedOptions; else standardTemplate">
      <ng-container *ngIf="ancestors.length === 0">
        <!-- With truncation tooltip when enabled and no custom tooltip -->
        <span
          *ngIf="!tooltip && isTooltipOnTruncateEnabled; else noTooltipOnTruncate"
          class="phx-select-option-label-content"
          [innerHTML]="highlightedLabel"
          phx-tooltip
          phx-tooltip-on-truncate
          [phxContent]="label"
        ></span>
        <!-- Without truncation tooltip -->
        <ng-template #noTooltipOnTruncate>
          <span
            class="phx-select-option-label-content"
            [innerHTML]="highlightedLabel"
            ></span>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="ancestors.length === 1">
        <ng-container *ngIf="!(tooltip && isCustomTooltipEnabled) && isTooltipOnTruncateEnabled; else ancestorOneNoTooltip">
          <span
            class="phx-select-option-label-content"
            phx-tooltip
            phx-tooltip-on-truncate
            [phxContent]="ancestors[0]?.label"
          >{{ ancestors[0]?.label }}</span>
          <i phx-icon [phxIcon]="chevronRightIcon" [size]="16"></i>
          <span
            class="phx-select-option-label-content"
            [innerHTML]="highlightedLabel"
            phx-tooltip
            phx-tooltip-on-truncate
            [phxContent]="label"
          ></span>
        </ng-container>
        <!-- Without truncation tooltip (custom tooltip has priority) -->
        <ng-template #ancestorOneNoTooltip>
          <span class="phx-select-option-label-content">{{ ancestors[0]?.label }}</span>
          <i phx-icon [phxIcon]="chevronRightIcon" [size]="16"></i>
          <span class="phx-select-option-label-content" [innerHTML]="highlightedLabel"></span>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="ancestors.length >= 2">
        <ng-container *ngIf="!(tooltip && isCustomTooltipEnabled) && isTooltipOnTruncateEnabled; else ancestorTwoNoTooltip">
          <div
            class="phx-select-option-label-content"
            [innerHTML]="highlightedLabel"
            phx-tooltip
            phx-tooltip-on-truncate
            [phxContent]="label"
          ></div>
          <div
            class="phx-select-option-label-subtext"
            [class.phx-select-option-label-subtext-truncate]="truncateSubtext"
            phx-tooltip
            phx-tooltip-on-truncate
            [phxContent]="ancestorsPath"
          >
            <span *ngFor="let ancestor of ancestors; let i = index" class="phx-select-option-label-ancestor">
              <span>{{ ancestor.label }}</span>
              <i *ngIf="i + 1 !== ancestors.length" phx-icon [phxIcon]="chevronRightIcon" [size]="16"></i>
            </span>
          </div>
        </ng-container>
        <!-- Without truncation tooltip (custom tooltip has priority) -->
        <ng-template #ancestorTwoNoTooltip>
          <div class="phx-select-option-label-content" [innerHTML]="highlightedLabel"></div>
          <div class="phx-select-option-label-subtext" [class.phx-select-option-label-subtext-truncate]="truncateSubtext">
            <span *ngFor="let ancestor of ancestors; let i = index" class="phx-select-option-label-ancestor">
              <span>{{ ancestor.label }}</span>
              <i *ngIf="i + 1 !== ancestors.length" phx-icon [phxIcon]="chevronRightIcon" [size]="16"></i>
            </span>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>

    <ng-template #standardTemplate>
      <!-- Label with truncation tooltip (only when enabled and no custom tooltip is provided for the option) -->
      <div
        *ngIf="!tooltip && isTooltipOnTruncateEnabled; else labelWithoutTooltip"
        class="phx-select-option-label-content"
        [innerHTML]="highlightedLabel"
        phx-tooltip
        phx-tooltip-on-truncate
        [phxContent]="label"
      ></div>
      <ng-template #labelWithoutTooltip>
        <div class="phx-select-option-label-content" [innerHTML]="highlightedLabel"></div>
      </ng-template>

      <!-- Subtext with truncation tooltip (only when enabled and no custom tooltip is provided for the option) -->
      <ng-container *ngIf="showSubText">
        <ng-container *ngIf="!tooltip && isTooltipOnTruncateEnabled; else subtextWithoutTooltip">
          <div
            *ngIf="highlightSubtext"
            class="phx-select-option-label-subtext"
            [class.phx-select-option-label-subtext-truncate]="truncateSubtext"
            [innerHTML]="highlightedSubText"
            phx-tooltip
            phx-tooltip-on-truncate
            [phxContent]="subText"
          ></div>
          <div
            *ngIf="!highlightSubtext"
            class="phx-select-option-label-subtext"
            [class.phx-select-option-label-subtext-truncate]="truncateSubtext"
            phx-tooltip
            phx-tooltip-on-truncate
            [phxContent]="subText"
          >{{ subText }}</div>
        </ng-container>
        <ng-template #subtextWithoutTooltip>
          <div *ngIf="highlightSubtext" class="phx-select-option-label-subtext" [class.phx-select-option-label-subtext-truncate]="truncateSubtext" [innerHTML]="highlightedSubText"></div>
          <div *ngIf="!highlightSubtext" class="phx-select-option-label-subtext" [class.phx-select-option-label-subtext-truncate]="truncateSubtext">{{ subText }}</div>
        </ng-template>
      </ng-container>
    </ng-template>
  </div>
  <ng-container *ngIf="suffixTemplate && !isLink">
    <ng-container *ngTemplateOutlet="suffixTemplate"></ng-container>
  </ng-container>
</ng-template>

<ng-template #treeExpandCollapseHandle>
  <span *ngIf="ancestors.length" class="phx-select-option-tree-lines-container">
    <span *ngFor="let item of ancestors" class="phx-select-option-tree-lines-wrapper">
      <phx-divider phxOrientation="vertical" phxMarginX="none" class="phx-select-option-tree-line"></phx-divider>
    </span>
  </span>
  <span class="phx-select-option-expand-collapse-icon-container">
    <span *ngIf="isNestedOptions" class="phx-select-option-expand-collapse-icon-wrapper" (click)="expandCollapseOption($event)">
      <i *ngIf="children?.length" [class.phx-tree-handle-rotate]="isExpanded" phx-icon [phxIcon]="chevronRightIcon"></i>
    </span>
    <phx-divider *ngIf="isExpanded" class="phx-select-option-expand-collapse-icon-line" phxOrientation="vertical"></phx-divider>
  </span>
</ng-template>

<ng-template #nestedMenuNavigator>
  <span class="phx-select-option-split">
    <phx-divider *ngIf="!isParentSelectionDisabled" phxOrientation="vertical" phxDividerHeight="20px"></phx-divider>
    <span class="phx-select-option-split-icon" (click)="showChildren($event)">
      <i phx-icon [phxIcon]="chevronRightIcon"></i>
    </span>
  </span>
</ng-template>
